import { render, staticRenderFns } from "./pg-table-radio.vue?vue&type=template&id=45f82181"
import script from "./pg-table-radio.vue?vue&type=script&lang=js"
export * from "./pg-table-radio.vue?vue&type=script&lang=js"
import style0 from "./pg-table-radio.vue?vue&type=style&index=0&id=45f82181&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports